import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { SdkStaff, SocketGetMarketResponseType } from 'src/AppState/sdk/staff';

const BetsIO = t.interface({
    legs: t.array(
        t.interface({
            eventId: t.number,
            marketId: t.number,
            selectionId: t.number,
        })
    ),
});

const isBetsDataType = createGuard(t.array(BetsIO));

export class ApiEvents {
    public constructor(private readonly sdkStaff: SdkStaff) {}

    public getSelectionsUUID = async (
        bets: unknown
    ): Promise<Record<number, { selectionId: number; uuid: string }>> => {
        if (isBetsDataType(bets)) {
            const tempEventMarketSelectionId: Array<{ eventId: number; marketId: number; selectionId: number }> = [];
            const marketsIds: Set<number> = new Set();
            const responses: Record<number, { selectionId: number; uuid: string }> = {};

            for (const bet of bets) {
                for (const leg of bet.legs) {
                    const isElemExist = tempEventMarketSelectionId.some((elem) => elem.selectionId === leg.selectionId);
                    if (isElemExist === false) {
                        marketsIds.add(leg.marketId);
                        tempEventMarketSelectionId.push({
                            eventId: leg.eventId,
                            marketId: leg.marketId,
                            selectionId: leg.selectionId,
                        });
                    }
                }
            }

            const requestsMap = Array.from(marketsIds).map((marketId) => {
                return this.sdkStaff.socket_get_market(marketId);
            });

            const allPromises = await Promise.all(requestsMap);

            for (const tempSelectionId of tempEventMarketSelectionId) {
                const uuid = this.getUUID(tempSelectionId, allPromises);

                if (uuid !== null) {
                    responses[tempSelectionId.selectionId] = {
                        selectionId: tempSelectionId.selectionId,
                        uuid: uuid,
                    };
                }
            }

            return responses;
        }

        return {};
    };

    public getUUID = (
        selectionModel: { eventId: number; marketId: number; selectionId: number },
        marketsList: Array<SocketGetMarketResponseType>
    ): string | null => {
        for (const response of marketsList) {
            const market = response.result ?? null;
            if (market !== null && market.id === selectionModel.marketId) {
                return market.selections[selectionModel.selectionId]?.uuid ?? null;
            }
        }

        return null;
    };
}
